import { withStyles } from "@material-ui/core";
import React, { useState } from 'react';
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Select from "react-select";

const styles = (theme) => ({
  dropYardsSelectFilter: {
    "& .select__control": {
      width: 70,
      backgroundColor: "transparent",
      minHeight: 28,
      maxHeight: 28,
      boxSizing: "border-box",
      borderRadius: 2,
      fontSize: theme.textFontSize,
      border: `1px solid ${theme.iconColor}`,
      cursor: "pointer",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`,
      },
      "& .select__value-container": {
        height: 24,
        color: theme.TextColor,
      },
      "& .select__single-value": {
        color: "inherit",
      },
      "& .select__placeholder": {
        top: "50%",
      },
      "& .select__indicators": {
        height: 24,
        "& .select__indicator": {
          padding: 5,
          height: 24,
        },
        "& .select__indicator-separator": {
          height: 24,
          margin: 0,
          display: "none",
        },
      },
    },
    "& .select__menu": {
      margin: 0,
      maxHeight: 140,
      border: `1px solid ${theme.iconColor}`,
      borderRadius: "0 0 2px 2px",
      borderTop: "none",
      "& .select__menu-list": {
        maxHeight: 139,
        borderRadius: 2,
        fontSize: theme.textFontSize,
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor,
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer",
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HeaderSelectedText,
      },
    },
  },
  dropYardsFilterDropdownIconStyle: {
    cursor: "pointer",
    color: theme.iconColor,
    marginRight: 4,
    marginTop: 3,
    fontSize: 18,
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
  },
  filterText: {
    fontSize: 14,
    color: theme.iconColor,
    paddingRight: 5,
    fontWeight: 400,
  },
});

const DropYardGridFilter = (props) => {
  const [selectedDropYardType, setSelectedDropYardType] = useState(
    props.options[0]
  );

  const filterDropYards = (option) => {
    if (selectedDropYardType?.value !== option.value) {
      props.selectGridFilter(option);
      setSelectedDropYardType(option);
    }
  };

  return (
    <div className={props.classes.filterContainer}>
      <div className={props.classes.filterText}>Select Terminal:</div>
      <Select
        value={selectedDropYardType}
        onChange={filterDropYards}
        options={props.options}
        classNamePrefix={"select"}
        className={props.classes.dropYardsSelectFilter}
        menuPlacement="auto"
        menuPosition="absolute"
        closeMenuOnSelect
        components={{
          DropdownIndicator: (innerProps) => (
            <ArrowDropDown
              {...innerProps.innerProps}
              className={props.classes.dropYardsFilterDropdownIconStyle}
            />
          ),
        }}
      />
    </div>
  );
};

export default withStyles(styles)(DropYardGridFilter);
